import AppStore from './AppStore';
import ApiStore from './ApiStore';
import UserStore from './UserStore';



export const store = {
  appStore: new AppStore(),
  apiStore: new ApiStore(),
  userStore: new UserStore()
};

//export default store;